import ProductPageContent from "components/ProductPageContent";
import { PRODUCT_PAGES } from "data/productPages";

function LimestoneMarblePage() {
  return <ProductPageContent data={PRODUCT_PAGES["limestone-marble"]} />;
}

export default LimestoneMarblePage;
